export const SignatureStatus = Object.freeze({
  PENDING: "PENDING",
  SIGNED: "SIGNED",
});
